/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'
import { Platform } from 'react-native'
import styled, { useTheme } from 'styled-components/native'

import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Button } from 'ui/designSystem/Button/Button'
import { ModalSimpleFooterProps } from 'ui/designSystem/ModalSimple/types'

export const ModalSimpleFooter: FunctionComponent<ModalSimpleFooterProps> = ({
  primaryButton,
  secondaryButton,
  tertiaryButton,
}) => {
  const { isDesktopViewport } = useTheme()

  const buttons = [
    primaryButton ? (
      <Button
        key="primary"
        variant="primary"
        color="brand"
        wording={primaryButton.wording}
        accessibilityLabel={primaryButton.accessibilityLabel}
        onPress={primaryButton.onPress}
      />
    ) : null,
    secondaryButton ? (
      <Button
        key="secondary"
        variant="secondary"
        color="neutral"
        wording={secondaryButton.wording}
        accessibilityLabel={secondaryButton.accessibilityLabel}
        onPress={secondaryButton.onPress}
      />
    ) : null,
    tertiaryButton ? (
      <Button
        key="tertiary"
        variant="tertiary"
        color="neutral"
        wording={tertiaryButton.wording}
        accessibilityLabel={tertiaryButton.accessibilityLabel}
        onPress={tertiaryButton.onPress}
      />
    ) : null,
  ].filter(Boolean)

  if (buttons.length === 0) return null

  const orderedButtons = isDesktopViewport ? [...buttons].reverse() : buttons

  return <FooterContainer gap={3}>{orderedButtons}</FooterContainer>
}

const FooterContainer = styled(ViewGap)(({ theme }) => ({
  flexShrink: 0,
  flexDirection: theme.isDesktopViewport ? 'row' : 'column',
  justifyContent: 'center',
  width: '100%',
  paddingHorizontal: theme.designSystem.size.spacing.xxl,
  paddingBottom: Platform.OS === 'ios' ? undefined : theme.designSystem.size.spacing.xxl,
  paddingTop: theme.designSystem.size.spacing.xl,
}))
